import styled from 'styled-components';
export const TipsContainer = styled.div.withConfig({
  displayName: "RelatedTipsstyle__TipsContainer",
  componentId: "sc-a741g-0"
})(["", " @media (max-width:", "){", "}"], {
  "marginBottom": "120px",
  "marginTop": "5rem"
}, ({
  theme
}) => theme.breakpoint.md, {
  "marginBottom": "5rem"
});